/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verifying_TitleInputs */



/**
* | output |
* | --- |
* | "Verifying Subscription" |
*
* @param {Creator_Checkout_Verifying_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verifying_title = /** @type {((inputs?: Creator_Checkout_Verifying_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verifying_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verification de l'abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement wird überprüft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica dell'abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка подписки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verificando suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证订阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションの確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता सत्यापित हो रही है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificando assinatura")
	return /** @type {LocalizedString} */ ("Verifying Subscription")
});